export function hasIntlDisplayNames(): boolean {
  try {
    const I = (globalThis as any).Intl;
    if (!I || typeof I.DisplayNames !== 'function') return false;

    // Some old/partial impls exist but are unusable.
    if (typeof I.DisplayNames.supportedLocalesOf !== 'function') return false;

    // Sanity: must support at least 'en' for type: 'language'
    const supported = I.DisplayNames.supportedLocalesOf?.(['en']);
    if (!Array.isArray(supported) || supported.length === 0) return false;

    const dn = new I.DisplayNames(['en'], { type: 'language' });
    if (!dn || typeof dn.of !== 'function') return false;

    const label = dn.of('en'); // should be a non-empty string like "English"
    return typeof label === 'string' && label.length > 0;
  } catch {
    return false;
  }
}
